export default "__VITE_ASSET__a73b3462__"